import React from "react";
import { connect } from "react-redux";

import { RootState } from "../../state";
import { ExperimentName, Experimenting } from "../reducers/experiments";

export interface ChildrenProps {
  experimenting?: Experimenting | null;
}

interface OwnProps {
  children: (props: ChildrenProps) => React.ReactNode;
  name: ExperimentName;
}

interface MappedProps {
  experimenting?: Experimenting | null;
}

type Props = OwnProps & MappedProps;

const WithExperiment: React.SFC<Props> = ({ children: render, experimenting }) => {
  const rendered = render({ experimenting });
  return React.isValidElement(rendered) ? rendered : null;
};

function mapStateToProps(state: RootState, props: OwnProps): MappedProps {
  return {
    experimenting: state.experiments[props.name],
  };
}

export default connect(mapStateToProps)(WithExperiment);



// WEBPACK FOOTER //
// ./frontend/src/common/components/WithExperiment.tsx